import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlHelper, UrlQueryParams } from 'app/_service/api-url-helper';
import { DnEmojiService } from 'app/_service/dn-emojis/emoji.service';
import { HttpClientHelper } from 'app/_service/http-helper';
import { delay, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class SocketService {
  host: string;
  constructor(
    private httpHelper: HttpClientHelper,
    private _dnEmojiService: DnEmojiService,
    private _apiHelper: ApiUrlHelper
  ) {
    this.host = this._apiHelper.APIV3_ENDPOINT();
  }
  sendMessage(data: any) {
    // return this.httpHelper.post(`${this.host}/user/SendMessage`, data, null);
    return this.httpHelper.post(`${this.host}/user/SendMessage`, {
      ...data,
      context: data.context ? this._dnEmojiService.emojiHtml2String(data.context) : undefined
    }, null, true)
  }
  getRecentlyRecords() {
    return this.httpHelper.get(`${this.host}/user/GetMyPrivateUser`).pipe(
      map(res => {
        if (!res.length) {
          return []
        }

        return res[0]?.list.map(l => {
          return {
            avatar: l.headImg,
            id: l.key,
            hasNew: l.isHasNotReadInfo,
            name: l.nickName,
            lastMessage: l.timeStamp,
            plainUserId: l.toUid,
            isOfficalUP: l.isOfficalUP,
            gid: l.gid,
            isOfficalSpeaker: l.isOfficalSpeaker,
          }
        });
      }),
    );
  }
  getRecentlyRecordsByUser(uid, id = 0, size = 10, currentUid = null) {
    return this.httpHelper.get(`${this.host}/user/GetUserMsgList` + `?touid=${uid}&id=${id}&size=${size}`).pipe(
      delay(200),
      map(res => {
        return {
          user: uid,
          messages: res[0]?.list.map(l => {
            return {
              sendTime: l.timeStamp,
              fromUid: l.fromUid,
              toUid: l.toUid,
              HeadImg: l.headImg,
              id: l.id,
              uid: l.key,
              type: currentUid === l.toUid ? "RECEIVE" : "SEND",
              messageType: l.messageType === 1 ? 'text' : 'image',
              context: l.messageType === 1
                ? l.processContext.replace(/\n/g, "<br>")
                : l.host + l.context.replace('//', '/'),
              IsOfficalUP: l.isOfficalUP,
              GID: l.gid,
              isOfficalSpeaker: l.isOfficalSpeaker,
            }
          }),
          allLoaded: res[0]?.list.length < 10,
          isblocked: res[0].isblocked
        }
      }),
    );
  }
  markMessagesAsRead(uid) {
    return this.httpHelper.get(`${this.host}/user/UpdReadMsg?touid=${uid}`);
  }
  markAllMessagesAsRead() {
    return this.httpHelper.get(`${this.host}/user/UpdReadMsg?touid=0&MessageType=1`);
  }
  clearChatHistory(uid) {
    return this.httpHelper.post(`${this.host}/user/ClearUserMsg?touid=${uid}`, { touid: uid }, null);
  }

  removeContact(uid) {
    return this.httpHelper.post(`${this.host}/user/CloseMsgUser?touid=${uid}`, { touid: uid }, null);
  }

  getSettings() {
    return this.httpHelper.get(`${this.host}/user/IsForOnlyFriend`).pipe(map(r => r[0]));
  }

  toggleSettingsFriendOnly() {
    return this.httpHelper.get(`${this.host}/user/SwitchForOnlyFriend`).pipe(map(r => r[0]));
  }

  report(data: any) {
    return this.httpHelper.post(`${this.host}/user/ComplainReq`, data, null, true).pipe(map(
      r => { return r.data }));
  }

  getFollowStatus(userId: string) {
    const url = this._apiHelper.APIV3_ENDPOINT() + "/user/getuserbaseinfo" + '?key=' + userId;
    return this.httpHelper.get(url).pipe(map(r => {
      let followStatus = 'NotFollowed'
      switch (r[0].attentionStatus) {
        case 0:
          followStatus = 'NotFollowed'
          break;
        case 1:
          followStatus = 'Followed'
          break;
        case 2:
          followStatus = 'BiWayFollowed'
          break;

        default:
          break;
      }
      return { userId: r[0].key, followStatus }
    }))
  }

  // uploadImage(image: string) {
  //   const uploadUrl = "https://m10.jssp.tv/v3/user/uploadpic";
  //   const httpOptions = {
  //     headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
  //   };
  //   const body = new URLSearchParams();
  //   body.set('t', image);
  //   return this.httpHelper
  //     .post(uploadUrl, body.toString(), httpOptions)
  //     .pipe(map(r => {
  //       console.log(r)
  //       return r[0];
  //     }));
  // }
}
